import React from 'react';
import { motion } from 'framer-motion';
import { Users } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section className="bg-brand-bg py-16 md:py-24 overflow-hidden" data-id="element-84">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-86">
          <motion.div className="flex-1 text-center lg:text-left" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-87">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-brand-primary leading-tight mb-6" data-id="element-88">
              {t('hero.title')}
            </h1>
            <p className="text-lg md:text-xl text-brand-text mb-8 leading-relaxed" data-id="element-89">
              {t('hero.subtitle')}
            </p>

            <div className="flex items-center justify-center lg:justify-start space-x-3 mb-10 text-brand-navy font-semibold bg-brand-alt py-3 px-5 rounded-full inline-flex" data-id="element-90">
              <Users className="w-6 h-6 text-brand-primary" data-id="element-91" />
              <span data-id="element-92">{t('hero.tagline')}</span>
            </div>

            <div className="flex flex-col items-center lg:items-start" data-id="element-93">
              <a href="https://wa.me/12013540888?text=Hola,%20quiero%20información%20para%20promocionar%20mi%20negocio" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-brand-accent text-brand-navy font-bold text-lg md:text-xl py-4 px-8 rounded-lg shadow-lg hover:bg-yellow-300 hover:scale-105 transition-all duration-300 text-center flex items-center justify-center min-h-[56px]" data-id="element-94">
                {t('hero.cta')}
              </a>
              <span className="text-sm text-gray-500 mt-3 font-medium" data-id="element-95">
                {t('hero.ctaSubtext')}
              </span>
            </div>
          </motion.div>

          <motion.div className="flex-1 w-full max-w-lg lg:max-w-none relative" initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-96">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]" data-id="element-97">
              <img src="https://cdn.magicpatterns.com/uploads/beMiEkGpU51rDxV7QqCBXm/Foto_2.png" alt="Equipo de marketing de campo interactuando con clientes en New Jersey" className="w-full h-full object-cover" data-id="element-98" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/40 to-transparent" data-id="element-99"></div>
            </div>

            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-brand-accent rounded-full opacity-20 blur-2xl -z-10" data-id="element-100"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-brand-primary rounded-full opacity-10 blur-2xl -z-10" data-id="element-101"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}